import { api } from './api'

/**
 * `POST /uploads/images` — multipart field `files` (repeat field for multiple).
 * Uses Axios with `onUploadProgress` for determinate progress UI.
 */
export async function uploadProductImages(
  fileList: FileList | File[] | null,
  onProgress?: (percent: number) => void,
): Promise<string[]> {
  const list: File[] = fileList ? Array.from(fileList as ArrayLike<File>) : []
  if (list.length === 0) {
    throw new Error('Select at least one image')
  }

  const formData = new FormData()
  for (const f of list) {
    formData.append('files', f)
  }
  const totalBytes = list.reduce((s, f) => s + f.size, 0)

  try {
    const { data } = await api.post('/uploads/images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (evt) => {
        if (!onProgress) return
        const total = evt.total || totalBytes || 0
        if (!total) return
        onProgress(Math.min(100, Math.round((evt.loaded / total) * 100)))
      },
    })

    const body = data as {
      success?: boolean
      message?: string
      data?: { items?: Array<{ url?: string }> }
    }

    if (!body?.success) {
      throw new Error(body?.message || 'Upload failed')
    }

    const items = body.data?.items
    if (!Array.isArray(items)) {
      throw new Error('Invalid upload response')
    }
    return items.map((item) => item.url).filter(Boolean) as string[]
  } catch (err: unknown) {
    const ax = err as { response?: { data?: { message?: string } }; message?: string }
    if (ax.response?.data && typeof ax.response.data === 'object') {
      const msg = (ax.response.data as { message?: string }).message
      if (msg) throw new Error(msg)
    }
    if (err instanceof Error) throw err
    throw new Error('Upload failed')
  }
}
